import { render, staticRenderFns } from "./CardRowMagazine.vue?vue&type=template&id=bf125504&"
import script from "./CardRowMagazine.vue?vue&type=script&lang=js&"
export * from "./CardRowMagazine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports